namespace Matrix.Data {
    export interface SecurityMatchRuleForm {
        RuleCode: Serenity.StringEditor;
        Description: Serenity.StringEditor;
        CommandText: Serenity.StringEditor;
        CreatedBy: StaticTextBlock;
        CreatedWhen: ReadOnlyDateTime;
        UpdatedBy: StaticTextBlock;
        UpdatedWhen: ReadOnlyDateTime;
        Version: StaticTextBlock;
    }

    export class SecurityMatchRuleForm extends Serenity.PrefixedContext {
        static formKey = 'Data.SecurityMatchRule';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!SecurityMatchRuleForm.init)  {
                SecurityMatchRuleForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = StaticTextBlock;
                var w2 = ReadOnlyDateTime;

                Q.initFormType(SecurityMatchRuleForm, [
                    'RuleCode', w0,
                    'Description', w0,
                    'CommandText', w0,
                    'CreatedBy', w1,
                    'CreatedWhen', w2,
                    'UpdatedBy', w1,
                    'UpdatedWhen', w2,
                    'Version', w1
                ]);
            }
        }
    }
}
